import { render, staticRenderFns } from "./salariesList.vue?vue&type=template&id=e7c7dc54&scoped=true&"
import script from "./salariesList.vue?vue&type=script&lang=js&"
export * from "./salariesList.vue?vue&type=script&lang=js&"
import style0 from "./salariesList.vue?vue&type=style&index=0&id=e7c7dc54&lang=scss&scoped=true&"
import style1 from "./salariesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c7dc54",
  null
  
)

export default component.exports